
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'

export default defineComponent(
{
    name: 'PasswordReset',
    components:
    {
        Heading
    },
    setup()
    {
        // Load vuex:
        const store = useStore()
        // Get authenticated user data:
        const authenticatedUser = store.getters['auth/getUser']
        // Return data:
        return {
            authenticatedUser
        }
    }
})
